import { useState,useEffect,useRef } from "react";
export default function Carrusel({imagenes}){
    const [index,setIndex]=useState(0)
    const [ancho,setAncho]=useState(0)
    const [alto,setAlto]=useState(0)
    const imgref=useRef(null)
    let anchos=[]
    let altos=[]
    async function dimensiones(imagenes) {
        const promesas = imagenes.map((url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = url;
                img.onload = () => resolve(img.width);
                img.onerror = () => resolve(0);
            });
        });
        const promesas2 = imagenes.map((url) => {
                return new Promise((resolve) => {
                const img = new Image();
                img.src = url;
                img.onload = () => resolve(img.height);
                img.onerror = () => resolve(0);
                });
        });
        anchos = await Promise.all(promesas);
        altos = await Promise.all(promesas2);
        setAncho(Math.max(...anchos))
        setAlto(Math.max(...altos))
    }
    useEffect(()=>{
        dimensiones(imagenes)
    })
    const onSetIndex=(n)=>{
        if (index==(imagenes.length-1) && n==1){
            setIndex(0)
        }
        else if (index==0 && n==-1){
            setIndex(imagenes.length-1)
        }
        else{
            setIndex(index+n)
        }
    }
    return (
        <div className="flex" style={{alignItems:'center',justifyContent:'space-around',margin:'2rem 0'}}>
            <a className="btn-form" style={{padding:'0.5rem 0.75rem',zIndex:1}} onClick={()=>{onSetIndex(-1)}}>◄</a>
            <div style={{width:ancho/100+"vw",height:alto/6+"vmin",display:'flex', alignItems:'center', justifyContent:'center'}}>
                <img src={imagenes[index]} style={{width:'45vw'}} ref={imgref}/>
            </div>
            <a className="btn-form" style={{padding:'0.5rem 0.75rem',zIndex:1}} onClick={()=>{onSetIndex(1)}}>►</a>
        </div>
    )
}